// src/lib/utils/design.ts

import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cx(...args: ClassValue[]): string {
  return twMerge(clsx(...args))
}

/**
 * Utility function to merge class names with Tailwind CSS classes
 * @param inputs Class names to merge
 * @returns Merged class names
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

// Tremor Raw focusInput [v0.0.1]

export const focusInput = [
  // base
  "focus:ring-2",
  // ring color
  "focus:ring-indigo-200 focus:dark:ring-indigo-700/30",
  // border color
  "focus:border-indigo-500 focus:dark:border-indigo-700"
]

// Tremor Raw focusRing [v0.0.1]

export const focusRing = [
  // base
  "outline outline-offset-2 outline-0 focus-visible:outline-2",
  // outline color
  "outline-indigo-500 dark:outline-indigo-500"
]

// Tremor Raw hasErrorInput [v0.0.1]

export const hasErrorInput = [
  // base
  "ring-2",
  // border color
  "border-red-500 dark:border-red-700",
  // ring color
  "ring-red-200 dark:ring-red-700/30"
]

export const shouldShowInteractiveGlobe = (): boolean => {
  // Check if running on client 
  if (typeof window === 'undefined') return false

  try {
    const nav = window.navigator as Navigator & { deviceMemory?: number }
    return !!(
      window.WebGLRenderingContext &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
      (nav.deviceMemory ?? 4) >= 4 &&
      (navigator.hardwareConcurrency ?? 4) >= 4
    )
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('utils/design: Error checking device capabilities', err)
    }
    return false
  }
}
